export class Transaccion {

    constructor(
        public transaccionId: number,
        public persona: number,
        public resultadoJson: string,
        public peticionOfuscada: string,
        public monto: number,
        public moneda: number,
        public shopperIp: string,
        public nombre: string,
        public correoElectronico: string,
        public messageType: string,
        public responseCode: string,
        public authorizationNumber: string,
        public fecha: string,
        public tarjeta: string,
        public factura: string,
        public felJson: string,
        public resultadoFel: boolean,
        public descripcion: string,
        public origenPago?: number,
        public ordenShopify?: string,
        public estado?: number
        

    ) {}
}
